module.exports = __webpack_public_path__ + "static/media/marker_marker.7e6ff127.svg";